/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFacebook = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23 12.074C23 5.96 18.083 1 12.01 1H12C5.927 1 1 5.96 1 12.074 1 17.6 5.03 22.169 10.29 23v-7.727H7.477v-3.2h2.811l.003-2.44c0-2.774 1.631-4.313 4.144-4.313 1.203 0 2.454.233 2.454.233V8.26h-1.378c-1.366 0-1.804.861-1.804 1.737l.004 2.077h3.055l-.489 3.199h-2.566V23C18.97 22.17 23 17.6 23 12.074"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFacebook as Facebook };
